<template>
  <div class="container-selete">
    <van-popup v-model="showPop" position="bottom" @close="close" :lock-scroll="false">
      <van-picker
        title=""
        show-toolbar
        :default-index="defaultIndex"
        :columns="columns"
        :cancel-button-text="$t('lang.BaseCommon.k006')"
        :confirm-button-text="$t('lang.BaseCommon.k028')"
        @confirm="confirm"
        @cancel="cancel"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    showPop: {
      type: Boolean,
      default: false,
    },
    defaultIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    confirm(val) {
      this.$emit('currentChoose', val)
    },
    cancel() {
      this.$parent.closeSeletePop()
    },
    close() {
      this.$parent.closeSeletePop()
    },
  },
}
</script>

<style lang="less" scoped></style>
